export default "__VITE_PUBLIC_ASSET__bce99243__"